import { initializeClickableRowsContacts } from './functions';
import { Modal } from 'bootstrap';

if (document.querySelector(".contacts")) {

    const addGroupEventButton = document.getElementById("add-group-event-button");
    const popupAddEvent = document.getElementById("popupAddEvent");
    const addEventForm = document.getElementById("addEventForm");
    const selectedContactsList = document.getElementById("selectedContactsList");
    const noContactsSelected = document.getElementById("noContactsSelected");

    if (addGroupEventButton) {
        addGroupEventButton.addEventListener("click", function () {
            let selectedContacts = document.querySelectorAll(".contact-checkbox:checked");

            if (selectedContacts.length === 0) {
                alert("❌ Please select at least one contact before adding an event.");
                return;
            }

            (new Modal(popupAddEvent)).show();

            document.body.classList.add("blurred");

            selectedContactsList.innerHTML = "";
            noContactsSelected.style.display = "none";

            selectedContacts.forEach(contact => {
                let contactID = contact.value;
                let listItem = document.createElement("li");
                listItem.classList.add("list-group-item");
                listItem.textContent = `ID: ${contactID}`;
                listItem.dataset.contactId = contactID;
                selectedContactsList.appendChild(listItem);
            });
        });
    }

    const submitCreateBulkLeads = document.getElementById("submit-create_bulk-leads");

    if (addEventForm && submitCreateBulkLeads) {
        addEventForm.addEventListener("submit", function (event) {
            event.preventDefault();

            let selectedContacts = [...document.querySelectorAll(".contact-checkbox:checked")].map(cb => cb.value);

            if (selectedContacts.length === 0) {
                alert("❌ No contacts selected.");
                return;
            }

            let jsonData = {
                ...Object.fromEntries(new FormData(addEventForm).entries()),
                contactIds: selectedContacts
            };

            axios.post("/leads/create-bulk", jsonData, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(response => {
                    const data = response.data;
                    if (data.success) {
                        alert("✅ Group event added successfully!");
                        (new Modal(popupAddEvent)).hide();
                    } else {
                        alert("❌ Error: " + data.error);
                    }
                })
                .catch(error => {
                    console.error("❌ Error submitting group event:", error);
                    alert("⚠️ Error: " + error.response.data.message);
                });
        });
    }

    initializeClickableRowsContacts();

    const multipleEmailLink = document.getElementById("multiple-email-link");
    multipleEmailLink.addEventListener("click", function () {
        let selectedContacts = document.querySelectorAll(".contact-checkbox:checked");
        let emails = '';
        selectedContacts.forEach(contact => {
            const parentRow = contact.closest('tr');
            const emailCell = parentRow.querySelector('td a[href^="mailto:"]');
            if (emailCell) {
                const email = emailCell.href.replace('mailto:', '');
                emails += email + ',';
            } else {
                console.error("No email found in parent row.");
            }
        });

        if (emails) {
            const emailLink = document.getElementById('multiple-email-link');

            emailLink.href = `mailto:${emails}`;
        } else {
            alert("❌ No emails found for selected contacts.");
        }
    });
}

if (document.querySelector(".contacts-edit")) {
    //
}
